/**
 * Converts OWA endpoint Url to B2 Service Url
 */
export function getB2ServiceEndpoint(owaEndpoint: string): string {
    // Handle Consumer account specific /owa/0/ (mailbox-specific) endpoints
    if (owaEndpoint.includes('/owa/0/')) {
        return owaEndpoint.replace('/owa/0/', '/messageservice/ows/');
    }
    // Handle standard /owa/ endpoints
    return owaEndpoint.replace('/owa/', '/messageservice/ows/');
}
